import { createAction } from 'typesafe-actions';

import { DriverLogoffIdPayload, DriverLogoffStatusPayload } from './driverLogoff.types';

export const setDriverLogoffId = createAction('SET_DRIVER_LOGOFF_ID')<DriverLogoffIdPayload>();
export const setDriverLogoffStatus = createAction('SET_DRIVER_LOGOFF_STATUS')<DriverLogoffStatusPayload>();